module.exports = __webpack_public_path__ + "img/service_cat_setting.1eb04b06.svg";